import { Select } from "components/common/Select";
import { useFieldContext } from "./formContext";
import type { SelectFieldProps } from "./types";

export const SelectField = ({
  label,
  isEditable,
  options,
  placeholder,
}: SelectFieldProps) => {
  const field = useFieldContext<string>();

  if (!isEditable) {
    return (
      <div className="text-sm">
        <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
        <div className="text-gray-900 break-words">
          {field.state.value || "—"}
        </div>
      </div>
    );
  }

  const error = field.state.meta.errors?.[0]?.message;

  return (
    <div className="text-sm">
      <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
      <Select
        value={field.state.value}
        onChange={field.handleChange}
        onBlur={field.handleBlur}
        options={options}
        placeholder={placeholder}
      />
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};
